import React, { useState } from "react";
import PostHooks from "../../../Api/PostHooks";
import { useForm } from "react-hook-form";
import AlertComponent from "../../../Components/AlertComponent";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import FormNumberInput from "../../../Components/FormNumberInput";

const WithdrawPoolForm = ({ user, onClose, onSuccess }) => {
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const [withdrawPoolLoading, withResp, withdrawPoolRequest] = PostHooks();

  const withdrawPool = async (e) => {
    try {
      let formData = {
        entity_id: user.id,
        amount: parseInt(e.amount),
      };

      const withResp = await withdrawPoolRequest({
        url: "/request_pool_fund",
        body: formData,
      });

      if (
        withResp &&
        withResp.status === 200 &&
        withResp.data.StatusCode === 0
      ) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Withdraw request sent, await approval!",
        });

        setTimeout(() => {
          onClose();
          onSuccess();
        }, 1000);
      } else {
        const errorMessage =
          withResp?.data?.StatusMessage ??
          withResp?.data?.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      console.log("withdraw pool err", error);
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(withdrawPool)} style={{ width: "auto" }}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <Box sx={{ mt: 2 }}>
        <FormNumberInput
          name="amount"
          control={control}
          label={`Amount`}
          rules={{
            required: "Please enter an amount!",
          }}
        />
      </Box>

      {/* <FormControl
        fullWidth
        error={!!errors.amount}
        sx={{
          mt: "5px",
        }}
      >
        <InputLabel htmlFor="amount">Amount</InputLabel>
        <OutlinedInput
          id="amount"
          type="number"
          {...register("amount", { required: true })}
          label="Username"
          inputProps={{ step: "any" }}
        />
        {errors.amount && (
          <FormHelperText>Please enter an amount!</FormHelperText>
        )}
      </FormControl> */}

      <Box
        sx={{
          gap: 2,
          pt: "40px",
          display: "flex",
          direction: "row",
          justifyContent: "flex-end",
        }}
      >
        <Button type="reset" variant="outlined" onClick={() => onClose()}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          type="submit"
          loading={withdrawPoolLoading}
        >
          Submit
        </LoadingButton>
      </Box>
    </form>
  );
};

export default WithdrawPoolForm;
